import { Injectable } from "@angular/core";
import {
    ConvertWeeklyDataDto,
    ManualEntryDto,
    ProductivityChartDto,
    TimeAndAttendanceServiceProxy,
    UserActivityTempCreateOrEditDto,
} from "@shared/service-proxies/service-proxies";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { ProductivityCandle } from "../models/productivity-candle";
import * as _ from "lodash";
import { DateTime } from "luxon";
import { ProductivityCandleSection } from "../models/productivity-candle-section";
import { tap } from "rxjs/operators";
import { AbpSessionService } from "abp-ng2-module";

@Injectable()
export class ProductivityBarService {
    viewDate: Date;
    constructor(private _timeAndAttendanceServiceProxy: TimeAndAttendanceServiceProxy, private _abpSessionService: AbpSessionService) { }

    // store for manual entry dto
    manuallyAddedData: ManualEntryDto[];

    // Method to fetch productivity bar data and modify it according to component input
    getProductivityBarData(
        userId: number,
        tenantId: number,
        timeSegment: number,
        startTime: number,
        endTime: number,
        date?: Date
    ): Observable<ProductivityCandle[]> {
        let startDate;
        let endDate;
        date = date ? date : this.viewDate;
        if (!date) {
            startDate = new Date();
            endDate = new Date();
        } else {
            startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());;
        }
        startDate.setHours(startTime, 0, 0, 0);
        endDate.setHours(endTime, 1, 0, 0);
        this.setViewDate(startDate);
        // return an observable by mapping it into ProductivityCandle[]
        //console.log("start",DateTime.fromJSDate(startDate));
        let d= new Date();
        return this._timeAndAttendanceServiceProxy
            .getProductivityBarInfo(userId, tenantId, timeSegment,DateTime.fromJSDate(this.setZeroTimeForLocalDate(startDate)), DateTime.fromJSDate(endDate), false,d.getTimezoneOffset(),DateTime.fromJSDate(this.setZeroTimeForLocalDate(d)),false)
            .pipe(
                // save manuallly added entry and return the productivity bar data
              
                map((r) => {/*console.log("r",r);*/
                    this.manuallyAddedData = r.manualAddEntryDto ?? [];
                    return r.productivityBarDto;
                }),
                map(r=>{
                    return r ? r.filter(x=>this.getLocalJsDate(x.startPointDate)>=startDate) : r;
                }   
                ),
                map(r => {
                    return _.uniqBy(r, (r => {
                        return r.startPointDate.hour * 60 + r.startPointDate.minute;
                    }))
                }),
                map((productivityChartDtoArray: ProductivityChartDto[]) => {
                    for (let i = 0; i < productivityChartDtoArray.length; i++) {
                        // console.log(productivityChartDtoArray[i].startPointDate.minute);
                        //console.log(productivityChartDtoArray.length)
                        //console.log(productivityChartDtoArray[i].startPointDate.hour + ":" + productivityChartDtoArray[i].startPointDate.minute);
                    }
                    // map it into array of productivity candles
                    let productivityCandleArray = productivityChartDtoArray.map((productivityChartDto: ProductivityChartDto) => {
                        return this.mapToProductivityCandle(productivityChartDto);
                    });
                
                    let no_of_Candles =  (endTime-startTime)*12;
                    if (productivityCandleArray.length < no_of_Candles) {
                        for (let i = productivityCandleArray.length; i <= no_of_Candles; i++){
                            productivityCandleArray.push(new ProductivityCandle(false));
                        }
                    }
                    //console.log("prodCandleArray",productivityCandleArray);
                    let  initalCandles= (startTime*12);
                    let lastCandle = endTime*12;
                    
                    let x = this.applyManualTime(productivityCandleArray, startTime, endTime, timeSegment);
                    
                    //console.log("XX",x);
                   let t= x.slice(initalCandles, lastCandle);
                    // logic for diffrent timezones
                    const candlesPerHour = 12; // Number of candles per hour
                    const startTimeHour = startTime; // Assuming start time is 9:00 AM
                    const endTimeHour = endTime; // Assuming end time is 12:00 AM (midnight)
                    let prodArray: ProductivityCandle[] = []
                    t.forEach((item, index) => {
                        if (item.isManualTime) { prodArray[index]= item; return;}
                        const date = new Date(item.date);
                        const hour = date.getHours();
                        const minute = date.getMinutes();
                        const timeIndex = (hour - startTimeHour) * candlesPerHour + Math.floor(minute / (60 / candlesPerHour));
                        if (timeIndex >= 0 && timeIndex < (endTimeHour - startTimeHour) * candlesPerHour) {
                            prodArray[timeIndex] = item;
                        }
                    });
                    for (let i = 0; i < prodArray.length; i++) {
                        if (!prodArray[i]) {
                            prodArray[i] = new ProductivityCandle(false, 0, 0, 0, 0, [], [], [], [], false, false, new Date(new Date().setHours(startTimeHour + Math.floor(i / candlesPerHour), (i % candlesPerHour) * (60 / candlesPerHour), 0, 0)));
                        }
                    }
                    t = prodArray;
                    return t;
                })
            );
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    // api call for adding manual entry time
    addManualEntry(id:number, minutes: number[], description: string, projectId: number, taskId: number, type: ProductivityCandleSection, selectedDate:Date,selectedTaskCategoryId:number): Observable<void> {
        const userActivityTempCreateOrEditDto = new UserActivityTempCreateOrEditDto();
        userActivityTempCreateOrEditDto.description = description;
        userActivityTempCreateOrEditDto.projectId = projectId;
        userActivityTempCreateOrEditDto.userProjectTaskId = taskId;
        userActivityTempCreateOrEditDto.userId = this._abpSessionService.userId;
        userActivityTempCreateOrEditDto.tenantId = this._abpSessionService.tenantId;
        userActivityTempCreateOrEditDto.productivityTypeId = type;
        userActivityTempCreateOrEditDto.startDateTime = this.minutesToUTCDateTime(minutes[0]);
        userActivityTempCreateOrEditDto.endDateTime = this.minutesToUTCDateTime(minutes[1]);
        userActivityTempCreateOrEditDto.dateAppliedFor = DateTime.fromJSDate(this.setZeroTimeForLocalDate(selectedDate));     
        userActivityTempCreateOrEditDto.taskCategoryId = selectedTaskCategoryId;   
        return this._timeAndAttendanceServiceProxy.addManualEntry(userActivityTempCreateOrEditDto);
    }

    applyManualTime(
        productivityCandleArray: ProductivityCandle[],
        startTimeHour: number,
        endTimeHour: number,
        timeSegment: number
    ): ProductivityCandle[] {
        let x = productivityCandleArray;
        this.manuallyAddedData.forEach((manuallyAddedSlot) => {
            let startJsDate = this.getLocalJsDate(manuallyAddedSlot.startTime);
            let endJsDate = this.getLocalJsDate(manuallyAddedSlot.endTime);
            let startMinutes = startJsDate.getHours() * 60 + startJsDate.getMinutes();
            let endMinutes = endJsDate.getHours() * 60 + endJsDate.getMinutes();
            let startIndex = Math.round((60 * startTimeHour) / 5 + ((startMinutes - startTimeHour * 60) / timeSegment - 1));
            startIndex = startIndex<0? 0:startIndex;
            let endIndex =Math.round((60*startTimeHour)/5 + ((endMinutes - startTimeHour * 60) / timeSegment - 1));
            for (let i = startIndex; i <= endIndex; i++) {
                if (x[i].isDataAvailable != undefined) {
                    x[i].isDataAvailable = true;
                }
                x[i].isManualTime = true;
                x[i].isApproved = manuallyAddedSlot.isApproved;
                x[i].date = startJsDate;
                x[i].TotalMinutes = (manuallyAddedSlot.endTime.toSeconds() -manuallyAddedSlot.startTime.toSeconds())/60;
                if (manuallyAddedSlot.productivityType === 1) {
                    x[i].makeAllProductive(manuallyAddedSlot.description);
                } else if (manuallyAddedSlot.productivityType === 2) {
                    x[i].makeAllUnproductive(manuallyAddedSlot.description);
                } else if (manuallyAddedSlot.productivityType === 3) {
                    x[i].makeAllNeutral(manuallyAddedSlot.description);
                }
            }
        });
        return x;
    }

    // Method to map a ProductivityChartDto -> ProductivityCandle
    mapToProductivityCandle(productivityChartDto: ProductivityChartDto): ProductivityCandle {
        let isDataAvailable: boolean = true;
        if (_.every(Object.values(productivityChartDto.dataChart), (x) => x === 0)) isDataAvailable = false;
        return new ProductivityCandle(
            isDataAvailable,
            productivityChartDto.dataChart.productive,
            productivityChartDto.dataChart.unProductive,
            productivityChartDto.dataChart.neutral,
            productivityChartDto.dataChart.private,
            productivityChartDto.productivityInfo,
            productivityChartDto.unProductivityInfo,
            productivityChartDto.neutralInfo,
            productivityChartDto.privateTimeInfo,
            false,
            false,
            this.getLocalJsDate(productivityChartDto.startPointDate)
        );
    }

    // Utility function
    calculateTotalSeconds(timeStamp: string): number {
        return timeStamp
            .split(":")
            .map((r) => parseInt(r))
            .map((r, i) => r * 60 ** (2 - i))
            .reduce((a, v) => (a += v), 0);
    }

    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? "0" + date.month : date.month}-${date.day < 10 ? "0" + date.day : date.day}T${
                date.hour < 10 ? "0" + date.hour : date.hour
            }:${date.minute < 10 ? "0" + date.minute : date.minute}:00`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    getLocalTimeStamp(date: DateTime): string {
        let localDate = this.getLocalJsDate(date);
        return localDate.toTimeString().split(" ")[0];
    }

    minutesToUTCDateTime(minutes: number): DateTime {
        let date = new Date();
        date.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
        date.setFullYear(this.viewDate.getFullYear(), this.viewDate.getMonth(),
            this.viewDate.getDate())
        return DateTime.fromJSDate(date);
    }

    secondsToDate(timeInSeconds: number): Date {
        const hours = Math.floor(timeInSeconds / 3600);
        let minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
        let seconds = timeInSeconds - hours * 3600 - minutes * 60;
        let date = new Date(new Date().toLocaleString());
        date.setHours(hours, minutes, seconds, 0);
        return date;
    }

    getDummyDateForWeeklyView(userId: number, tenantId: number, passMinute: number, filterStartDate: DateTime, filterEndDate: DateTime, isBagroundJobCall: boolean): Observable<ConvertWeeklyDataDto[]> {
        return this._timeAndAttendanceServiceProxy.getWeeklyProductiveBarData(userId, tenantId, passMinute, filterStartDate, filterEndDate, isBagroundJobCall,(new Date).getTimezoneOffset(),DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())),false).pipe(map((r) => {
            if (r) return r.slice(0,132)
            if (!r) return []
        }));
    }

    getDummyDateForMonthlyView(): Observable<ConvertWeeklyDataDto[]> {
        return this._timeAndAttendanceServiceProxy.getMonthlyProductivityBarData().pipe(
            map((r) => r.slice(0, 132))
        );
    }

    deleteManualTime(id: number): Observable<void> {
        return this._timeAndAttendanceServiceProxy.deleteManualEntry(id);
    }

    getManualTime(): ManualEntryDto[] {
        return this.manuallyAddedData;
    }

    jsDateToMinutesInTheDay(date: Date): number {
        return date.getHours() * 60 + date.getMinutes();
    }

    setViewDate(date: Date){
      
        this.viewDate = date;
    }
}
